<template>
  <b-steps
    v-model="activeStep"
    :animated="false"
    :has-navigation="false"
    mobile-mode="compact"
    size="is-small"
  >
    <b-step-item step="1" :label="$t('lockerDelivery.step1start')" />

    <b-step-item step="2" :label="$t('lockerDelivery.step2delivery')" />

    <b-step-item step="3" :label="$t('lockerDelivery.step3pickup')" />
  </b-steps>
</template>

<script>
export default {
  props: ["status"],

  data() {
    return {
      activeStep: 0
    };
  },

  mounted() {
    this.activeStep =
      this.status === "waitingPackage"
        ? 0
        : this.status === "accessedByCourier" ||
          this.status === "deliveryConfirmed" ||
          this.status === "waitingPickUp"
        ? 1
        : this.status === "accessedByClient" ||
          this.status === "pickupConfirmed"
        ? 2
        : 0;
    document.getElementsByClassName("step-content")[0].style.display = "none";
  }
};
</script>
